import styled from 'styled-components';
import media from '../theme/media';
import { fontSans, fontMono } from '../theme/config';

export const Overlay = styled.div`
    height: calc(100vh - 176px);
    top: 88px;
    position: fixed;
    width: 100%;
    display: flex;
    &.true {
      display: none;
    }
    &.false {
      display: flex;
    }
`;

export const OverlayContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    
    > div:first-child {
      width: 30%;
    }
    
    > div:last-child {
      width: 60%;
    }
`;

export const OverlayFooter = styled.div`
    position: fixed;
    bottom: 0;
    height: 88px;
`;

export const OverlaySummery = styled.div`
    display: block;
    margin-top: 2rem;
    ul {
      margin-block-start: 0;
      margin-block-end: 0;
      padding-inline-start: 24px;
    }
    &.true {
      display: none;
    }
`;


// WEBPACK FOOTER //
// src/theme/overlay.js